import type { SedSectionId } from '../../types/siteEvidence';
import { filterWaterStorageZeros } from './waterStorageEvidence';

/** Missing-value tokens are absence, never an affirmative source statement. */
export function isMissingDocumentValue(value: unknown): boolean {
  return value == null || (typeof value === 'number' && !Number.isFinite(value))
    || (typeof value === 'string' && /^(?:\s*|null|undefined|n\/?a|not\s+available)$/i.test(value.trim()));
}

/** Remove model placeholders recursively without changing meaningful false/zero. */
export function stripMissingDocumentValues(data: Record<string, unknown>): void {
  for (const [key, value] of Object.entries(data)) {
    if (isMissingDocumentValue(value)) { delete data[key]; continue; }
    if (Array.isArray(value)) {
      data[key] = value.filter(item => !isMissingDocumentValue(item));
      if ((data[key] as unknown[]).length === 0) delete data[key];
    } else if (value && typeof value === 'object') {
      stripMissingDocumentValues(value as Record<string, unknown>);
      if (Object.keys(value).length === 0) delete data[key];
    }
  }
}

/** A gas transmission map cannot establish electric grid supply or voltage. */
export function sanitizeDocumentSectionFields(section: SedSectionId, data: Record<string, unknown>, body: string): void {
  stripMissingDocumentValues(data);
  if (section === 'waterResource') filterWaterStorageZeros(data, body);
  if (section !== 'grid') return;
  const electric = /\b\d+(?:\.\d+)?\s*(?:kV|MVA)\b|\b(?:electric(?:al)?|power|grid)\b[^.!?\n]{0,80}\b(?:supply|capacity|voltage|substation|transmission|distribution|available)\b/i;
  if (!electric.test(body) && /\b(?:natural\s+gas|gas\s+pipeline|pipeline|compressor|gas\s+pool)\b/i.test(body)) {
    for (const key of Object.keys(data)) delete data[key];
  }
}
